// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import times from 'lodash/times';

import { SeatingOption, IOptionGroup } from '../../classes/seating-option';
import CheckboxGroup from '../../common/checkbox/checkbox-group';
import RadioGroup from '../../common/radio/radio-group';
import QuantitySelect from '../../common/quantity-select/quantity-select';
import { Html } from '../../helpers/html-helpers';

interface ISeatingOptionGroupProps {
    key: string;
    id: string;
    groupSeatSelectedQuantity: number;
    groupName: string;
    groupSeatLimit: number;
    seatingOptions: Array<SeatingOption>;
    isCheckbox: boolean;
    onSelectSeatingOptionQuantity: (seatingOptionGroupId: string, quantity: number) => void;
    removeSeatingOptionGroup: (seatingOptionGroupId: string) => void;
    onSelectSeatingOption: (seatingOptionGroupId: string, seatingOptions: Array<any>, seatingOptionToggle: boolean) => void;
    remainingSelectableTickets: number;
    seatingOptionSubHeading: string;
    groupSeatLimitText: string;
    maxQuantitySeatingOptionSelectedError: string;

    requiresSeatQuantitySelection: boolean;

    isDisabled: boolean;
    hasUnlockSeatCriteria: boolean;
    seatLimitPerUnlockSeat: number;

    unlockFilterMessage: string;
    checked: boolean;
}

class SeatingOptionGroupFilter extends React.Component<ISeatingOptionGroupProps, any>{

    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked,
            selectedQuantity: props.selectedQuantity
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            ...this.state,
            selectedQuantity: nextProps.selectedQuantity, checked: nextProps.checked
        });
    }

    render() {

        let seatQuantities = times(this.props.groupSeatLimit, i => i + 1);

        if (this.props.hasUnlockSeatCriteria && this.props.seatLimitPerUnlockSeat > 0) {
            seatQuantities = times(this.props.seatLimitPerUnlockSeat, i => i + 1);
        }
        const seatingOptionCount = times(this.props.seatingOptions.length, i => i + 1);
        const useTagAlert = '<use xlink:href="#icon-alert" />';

        let hasDescription = this.props.groupSeatLimitText?.length > 0;
        let hasSelectQuantitySelect = this.props.requiresSeatQuantitySelection;
        let hasSeatingOptions = this.props.seatingOptions.length > 0;

        return (
            <div className="toggle-container">

                <input id={this.props.id} className="toggle-input" disabled={this.props.isDisabled} type="checkbox" checked={this.state.checked} onChange={() => {
                    this.setState({ checked: !this.state.checked });
                    if (this.state.checked) {
                        this.props.removeSeatingOptionGroup(this.props.id);
                    } else {
                        this._onSeatingOptionQuantitySelect(0);
                    }
                }} />
                <label htmlFor={this.props.id} className={"toggle-label" + (this.props.isDisabled ? " disabled" : "")}><span>{this.props.groupName}</span></label>

                {
                    this.props.isDisabled ?
                        <div className="ticket-selection-quantity-max-message">
                            <svg className="ticket-selection-quantity-max-alert" dangerouslySetInnerHTML={{ __html: useTagAlert }} />
                            {this.props.unlockFilterMessage}
                        </div>
                        : null
                }
                {
                    this.state.checked && (hasDescription || hasSelectQuantitySelect || hasSeatingOptions) ?
                        <div className="toggle-content">
                            {
                                (hasDescription) && Html.renderParagraph(this.props.groupSeatLimitText, 'toggle-content-headline')
                            }
                            {
                                hasSelectQuantitySelect ?
                                    <>
                                        <QuantitySelect
                                            canAdd={this.props.groupSeatSelectedQuantity < this.props.groupSeatLimit && this.props.remainingSelectableTickets > 0}
                                            canRemove={this.props.groupSeatSelectedQuantity > 0}
                                            componentClassName="seat-info-prices-button"
                                            quantity={this.props.groupSeatSelectedQuantity}
                                            onSelectQuantity={this._onSeatingOptionQuantitySelect}
                                        />

                                        {
                                            this.props.groupSeatLimit > 0 && this.props.groupSeatSelectedQuantity === this.props.groupSeatLimit ?
                                                <div className="ticket-selection-quantity-max-message">
                                                    <svg className="ticket-selection-quantity-max-alert" dangerouslySetInnerHTML={{ __html: useTagAlert }} />
                                                    <p>
                                                        {this.props.maxQuantitySeatingOptionSelectedError.replace("{0}", this.props.groupName)}
                                                    </p>
                                                </div>
                                                : null
                                        }

                                    </>
                                    : null
                            }

                            {
                                hasSeatingOptions ?
                                    <>
                                        <p className="toggle-content-headline">
                                            {this.props.seatingOptionSubHeading}
                                        </p>
                                        <div className="form-container">
                                            {this.props.isCheckbox ?
                                                <CheckboxGroup group={{ options: this.props.seatingOptions } as IOptionGroup}
                                                    selectedOptions={this.props.seatingOptions.filter(option => option.selected)}
                                                    stateChangeFunction={this._selectOption.bind(this)} id={null}
                                                    allText="" showAllOption={false}
                                                />
                                                :
                                                <RadioGroup disabled={false} group={{ options: this.props.seatingOptions } as IOptionGroup}
                                                    selectedOptions={this.props.seatingOptions.filter(option => option.selected)}
                                                    stateChangeFunction={this._selectOption.bind(this)} id={null} />
                                            }

                                        </div>
                                    </>
                                    : null
                            }
                        </div> : null
                }
            </div>);
    }

    _onSeatingOptionQuantitySelect = (quantity) => {
        this.props.onSelectSeatingOptionQuantity(this.props.id, quantity);
    };

    _selectOption(selectedOptions: Array<any>) {
        this.props.onSelectSeatingOption(this.props.id, selectedOptions, selectedOptions[0].selected);
    }

}

export default SeatingOptionGroupFilter;